import { render, staticRenderFns } from "./goods-vip-all-protocol.vue?vue&type=template&id=76673fdd&scoped=true"
import script from "./goods-vip-all-protocol.vue?vue&type=script&lang=js"
export * from "./goods-vip-all-protocol.vue?vue&type=script&lang=js"
import style0 from "./goods-vip-all-protocol.vue?vue&type=style&index=0&id=76673fdd&prod&lang=scss"
import style1 from "./goods-vip-all-protocol.vue?vue&type=style&index=1&id=76673fdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76673fdd",
  null
  
)

export default component.exports